import { payableDataSchema } from '../../Payable.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';

// Merge ServicesProviderGenericData and PayableData to create intersection type
const payableServicesProviderDataSchema = servicesProviderGenericDataSchema.merge(payableDataSchema);

export { payableServicesProviderDataSchema };
//# sourceMappingURL=ServicesProviderPayableData.js.map
